export default __webpack_public_path__ + "static/okr-linking-33a168caf08a75f56806317601762f96.webm";